"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var Small_1 = require("./svg/Small");
var Medium_1 = require("./svg/Medium");
var Large_1 = require("./svg/Large");
var Avatar = /** @class */ (function (_super) {
    tslib_1.__extends(Avatar, _super);
    function Avatar(props, context) {
        return _super.call(this, props, context) || this;
    }
    Avatar.prototype.renderSvg = function () {
        var _a = this.props, theme = _a.theme, small = _a.small, large = _a.large;
        var SVG = small ? Small_1.default : large ? Large_1.default : Medium_1.default;
        return React.createElement(SVG, { outlineClassName: theme.outline, backClassName: theme.back });
    };
    Avatar.prototype.renderImage = function () {
        var imageUrl = this.props.imageUrl;
        return React.createElement("img", { src: imageUrl });
    };
    Avatar.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, imageUrl = _b.imageUrl, small = _b.small, large = _b.large, dark = _b.dark, blue = _b.blue, others = tslib_1.__rest(_b, ["theme", "className", "imageUrl", "small", "large", "dark", "blue"]);
        var classes = classnames_1.default(theme.avatar, className, (_a = {},
            _a[theme.small] = small,
            _a[theme.large] = large,
            _a[theme.dark] = dark,
            _a[theme.blue] = blue,
            _a));
        return (React.createElement("div", tslib_1.__assign({}, others, { className: classes }),
            this.renderSvg(),
            imageUrl ? this.renderImage() : null));
    };
    Avatar.defaultProps = {
        small: false,
        large: false,
        dark: false
    };
    return Avatar;
}(React.Component));
exports.default = Avatar;
